// frontend/src/services/paymentService.ts
import api from './api';
import { 
    Comision,
    VendedoraStats,
    ModistaStats,
    ComisionResumen,
    DashboardPagos,
    ApiResponse 
} from '../types';

const paymentService = {
    /**
     * Obtener dashboard de pagos
     */
    async getDashboard(mes?: number, anio?: number, fechaInicio?: string, fechaFin?: string): Promise<DashboardPagos> {
        const params = new URLSearchParams();
        if (mes) params.append('mes', mes.toString());
        if (anio) params.append('anio', anio.toString());
        if (fechaInicio) params.append('fecha_inicio', fechaInicio);
        if (fechaFin) params.append('fecha_fin', fechaFin);

        const response = await api.get<ApiResponse<DashboardPagos>>(
            `/payments/dashboard?${params.toString()}`
        );
        return response.data.data!;
    },

    /**
     * Obtener todas las comisiones con filtros
     */
    async getComisiones(filters?: {
        usuario_id?: string;
        tipo?: string;
        estado?: string;
        fecha_inicio?: string;
        fecha_fin?: string;
    }): Promise<Comision[]> {
        const params = new URLSearchParams();
        if (filters?.usuario_id) params.append('usuario_id', filters.usuario_id);
        if (filters?.tipo) params.append('tipo', filters.tipo);
        if (filters?.estado) params.append('estado', filters.estado);
        if (filters?.fecha_inicio) params.append('fecha_inicio', filters.fecha_inicio);
        if (filters?.fecha_fin) params.append('fecha_fin', filters.fecha_fin);

        const response = await api.get<ApiResponse<Comision[]>>(
            `/payments/comisiones?${params.toString()}`
        );
        return response.data.data || [];
    },

    /**
     * Calcular comisiones de vendedoras
     */
    async calcularComisionesVendedoras(
        fechaInicio: string,
        fechaFin: string
    ): Promise<{
        periodo: { inicio: string; fin: string };
        vendedoras: VendedoraStats[];
        resumen: any;
    }> {
        const response = await api.get<ApiResponse<any>>(
            `/payments/comisiones/vendedoras?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`
        );
        return response.data.data!;
    },

    /**
     * Calcular comisiones de modistas
     */
    async calcularComisionesModistas(
        fechaInicio: string,
        fechaFin: string
    ): Promise<{
        periodo: { inicio: string; fin: string };
        modistas: ModistaStats[];
        resumen: any;
    }> {
        const response = await api.get<ApiResponse<any>>(
            `/payments/comisiones/modistas?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`
        );
        return response.data.data!;
    },

    /**
     * Registrar comisión
     */
    async registrarComision(data: {
        usuario_id: string;
        tipo: string;
        monto: number;
        porcentaje: number;
        periodo_inicio: string;
        periodo_fin: string;
        notas?: string;
        venta_id?: number;
        ticket_id?: number;
    }): Promise<Comision> {
        const response = await api.post<ApiResponse<Comision>>(
            '/payments/comisiones',
            data
        );
        return response.data.data!;
    },

    /**
     * Marcar comisión como pagada
     */
    async marcarComoPagada(id: number, notas?: string): Promise<Comision> {
        const response = await api.patch<ApiResponse<Comision>>(
            `/payments/comisiones/${id}/pagar`,
            { notas }
        );
        return response.data.data!;
    },

    /**
     * Obtener resumen de comisiones por usuario
     */
    async getResumenPorUsuario(usuarioId: string): Promise<ComisionResumen> {
        const response = await api.get<ApiResponse<ComisionResumen>>(
            `/payments/comisiones/usuario/${usuarioId}`
        );
        return response.data.data!;
    }
};

export { paymentService };
export default paymentService;
